import { InstallationRepository } from '@context/Installations/domain/InstallationRepository'

import { RobotTypeStatus } from '../domain/RobotType'

export function getRobotTypes(installationRepository: InstallationRepository, status?: RobotTypeStatus) {
  return installationRepository.findAllRobotTypes(status)
}
